module.exports = __webpack_public_path__ + "img/dinkes.e228db99.svg";